import {Input} from '@angular/core';
import {OnInit} from '@angular/core';

import {IInputFile} from './file.model';

export interface IUploadSettings {
    accept: string[];
    maxSize: number;
    multiple: boolean;
}

export const DEFAULT_UPLOAD_SETTINGS: IUploadSettings = {
    accept: [
        '.pdf', '.bmp', '.tif', '.tiff', '.jpg', '.jpeg', '.jfif', '.jp2',
        '.jpc', '.jb2', '.png', '.gif', '.djvu', '.djv', '.pcx', '.dcx'
    ],
    maxSize: 25 * 1024 * 1024,
    multiple: true
};

export abstract class AbstractInputFileDirective implements OnInit {

    protected _accept: string[];

    protected _maxSize: number;

    protected _multiple: boolean;

    @Input()
    settings: IUploadSettings;

    ngOnInit(): void {
        const settings = this.settings || DEFAULT_UPLOAD_SETTINGS;
        this._accept = settings.accept || [];
        this._maxSize = settings.maxSize || Number.MAX_VALUE;
        this._multiple = settings.multiple || false;
    }

    protected _checkError(file: IInputFile): IInputFile {
        if (file.size === 0) {
            file.error = 'empty';
        } else if (file.size > this._maxSize) {
            file.error = 'maximum';
        } else if (this._accept.length && this._accept.indexOf(file.extension) === -1) {
            file.error = 'format';
        }
        return file;
    }

    protected _onFileSelect(files: FileList): IInputFile[] {
        const result = [];
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            result.push(this._checkError({
                extension: (file.name.toLowerCase().match(/\.\w+$/) || [])[0],
                name: file.name,
                size: file.size,
                source: file
            }));
        }
        return result;
    }

}
